module.exports = __webpack_public_path__ + "static/img/post3.8bd7b9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/post3.jpg
// module id = eWZr
// module chunks = 192